import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';

import { Page } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';

import { BehaviorDataService } from '../../service/behaviorData.service';
import { LoaderService } from '../../service/loader.service';

@Component({
    selector: 'qd-loader',
    templateUrl: './loader.component.html',
    styles: [
        `
            .loading,
            .loading-v2,
            .loading-v3 {
                position: absolute;
            }
        `,
    ],
    imports: [NgClass],
})
export class LoaderComponent implements OnInit, OnDestroy {
    private loaderService = inject(LoaderService);
    private behaviorData = inject(BehaviorDataService);
    private changeDetectorRef = inject(ChangeDetectorRef);
    private page = inject(Page);

    subscriptions$: Subscription[] = [];
    isLoading: boolean;
    showEpcotSpinner: boolean = false;
    universalLoader: boolean = true;
    loadingVersion = 'loading-v2';

    constructor() {
        this.getTheme();
    }
    getTheme() {
        const themeName = this.page.theme;
        if (themeName?.toLowerCase().includes('mgm') || themeName?.toLowerCase().includes('sports-interaction')) {
            this.showEpcotSpinner = true;
        } else if (themeName?.toLowerCase().includes('betboo-br') || themeName?.toLowerCase().includes('sportingbet-br')) {
            this.loadingVersion = 'loading-v3';
        } else {
            this.loadingVersion = 'loading-v2';
        }
    }
    ngOnInit() {
        this.subscriptions$.push(
            this.loaderService.isLoading.subscribe((res) => {
                this.isLoading = res;
                this.changeDetectorRef.detectChanges();
            }),
        );
        this.subscriptions$.push(
            this.behaviorData?.getUserConfig.subscribe((data: any) => {
                if (data) {
                    this.getTheme();
                    const { universal_loading_enabled } = data?.configParams || {};
                    this.universalLoader = universal_loading_enabled === 'Y';
                }
            }),
        );
    }
    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
